<div id="main" class="myw-content iom-bgclr d-flex flex-column flex-fill">
  <div class="myw-inner myw-container py-4">
    <h1 class="fs-20 text-primary mb-4">Text Analytics Configuration</h1>
    <div class="form-row row myw-grid">
      <div class="col-3">
        <div *ngIf="instance" class="iom-section-deep iom-side-menu-section">
          <div class="d-flex iom-sd-check">
            <p class="fs-14 myw-500">Portfolio</p>
            <div class="d-flex ml-auto">
              <div class="form-inline">
                <!-- <label class="myw-checkbox">
                  <input type="checkbox" id="SelectAll" name="domain-option">
                  <span>Select All</span>
                </label> -->
              </div>
            </div>
          </div>
          <!-- Menu -->
          <div *ngIf="treeDataParent && (envVar.Env == 'FDS_ManualUpload' || envVar.Env == 'SAAS_ManualUpload') && this.SessionService.getSessionStorageItem('userType') == '1'" class="iom-sidebar" style="overflow: auto;height: 320px;">
            <div class="iom-sidebar-nav-list">
              <a href="javascript:;" (click)="dispalyChaild($event);"
                 class="iom-sidebar-parent iom-sidebar-nav iom-sidebar-nav-toggle open active">
                <img src="assets/images/automation.svg" alt="" class="iom-active-parent">
                 <span class="iom-menu-item-name" title='Delivery Construct Type: {{treeDataParent["DeliveryConstructType"]}}'>{{treeDataParent.DeliveryConstruct}}</span>
                <label  [ngClass]="{chkdisabled: treeDataParent['DeliveryConstructType'] == 'DS'}" title="{{ treeDataParent['DeliveryConstructType'] == 'DS' ? 'Cannot create deepdive at this level' : ''}}" class="myw-checkbox">
                  <input class="chkbox" type="checkbox" [attr.disabled]="treeDataParent['DeliveryConstructType'] == 'DS'? 'disable' : null"
                          (click)="checkUncheckChild($event);"
                         value='{{treeDataParent["DeliveryConstruct"] + "~^~" + treeDataParent["DeliveryConstructUId"] + "~^~" + treeDataParent["DeliveryConstructType"] + "~^~" + treeDataParent["ParentDeliveryConstructType"] + "~^~" + treeDataParent["ParentDeliveryConstructUId"] + "~^~" + treeDataParent["Status"] + "~^~" + treeDataParent["Domain"] + "~^~" + treeDataParent["ParentE2EUID"]}}'
                         id="{{treeDataParent['DeliveryConstructType']}}" name="dc">
                  <span></span>
                </label>
              </a>
              <div class="iom-sidebar-nav-cont iom-sidebar-nav-link iom-sidebar-child show">
                <div *ngFor="let d of treeData" class="iom-sidebar-body">
                  <a href="javascript:;" (click)="dispalyChaild($event);" title='Delivery Construct Type: {{d.DeliveryConstructType}}'
                     class="iom-sidebar-nav io m-sidebar-nav-toggle open active">
                    <img src="assets/images/automation.svg" alt=""> <span class="iom-menu-item-name">
                      {{d.DeliveryConstruct}}
                    </span>
                    <label  [ngClass]="{chkdisabled: d.DeliveryConstructType == 'DS'}" title="{{ d.DeliveryConstructType == 'DS' ? 'Cannot create deepdive at this level' : ''}}"  class="myw-checkbox">
                      <input class="chkbox" type="checkbox"
                              [attr.disabled]="d.DeliveryConstructType == 'DS'? 'disable' : null"
                             value='{{d.DeliveryConstruct + "~^~" + d.DeliveryConstructUId + "~^~" + d.DeliveryConstructType + "~^~" + d.ParentDeliveryConstructType + "~^~" + d.ParentDeliveryConstructUId + "~^~" + d.Status + "~^~" + d.Domain + "~^~" + d.ParentE2EUID}}'
                             (click)="checkUncheckChild($event);" id="{{d.DeliveryConstructType}}" name="dc">
                      <span></span>
                    </label>
                  </a>
                  <div class="iom-sidebar-nav-cont iom-sidebar-nav-link iom-sidebar-child show">
                    <div *ngFor="let d1 of d.Children" class="iom-sidebar-body">
                      <a href="javascript:;" (click)="dispalyChaild($event);" title='Delivery Construct Type: {{d1.DeliveryConstructType}}'
                         class="iom-sidebar-nav iom-sidebar-nav-toggle open active">
                        <img src="assets/images/automation.svg" alt=""> <span class="iom-menu-item-name">{{d1.DeliveryConstruct}}</span>
                        <label [ngClass]="{chkdisabled: d1.DeliveryConstructType == 'DS'}" title="{{ d1.DeliveryConstructType == 'DS' ? 'Cannot create deepdive at this level' : ''}}"  class="myw-checkbox">
                          <input class="chkbox" type="checkbox"
                          [attr.disabled]="d1.DeliveryConstructType == 'DS'? 'disable' : null"
                                 value='{{d1.DeliveryConstruct + "~^~" + d1.DeliveryConstructUId + "~^~" + d1.DeliveryConstructType + "~^~" + d1.ParentDeliveryConstructType + "~^~" + d1.ParentDeliveryConstructUId + "~^~" + d1.Status + "~^~" + d1.Domain + "~^~" + d1.ParentE2EUID}}'
                                 (click)="checkUncheckChild($event);" id="{{d1.DeliveryConstructType}}" name="dc">
                          <span></span>
                        </label>
                      </a>
                      <div class="iom-sidebar-nav-cont iom-sidebar-nav-link iom-sidebar-child show">
                        <div *ngFor="let d2 of d1.Children" class="iom-sidebar-body">
                          <a href="javascript:;" (click)="dispalyChaild($event);" title='Delivery Construct Type: {{d2.DeliveryConstructType}}'
                             class="iom-sidebar-nav iom-sidebar-nav-toggle open active">
                            <img src="assets/images/automation.svg" alt=""> <span class="iom-menu-item-name">{{d2.DeliveryConstruct}}</span>
                            <label [ngClass]="{chkdisabled: d2.DeliveryConstructType == 'DS'}" title="{{ d2.DeliveryConstructType == 'DS' ? 'Cannot create deepdive at this level' : ''}}"  class="myw-checkbox">
                              <input class="chkbox" type="checkbox"
                                     value='{{d2.DeliveryConstruct + "~^~" + d2.DeliveryConstructUId + "~^~" + d2.DeliveryConstructType + "~^~" + d2.ParentDeliveryConstructType + "~^~" + d2.ParentDeliveryConstructUId + "~^~" + d2.Status + "~^~" + d2.Domain + "~^~" + d2.ParentE2EUID}}'
                                     (click)="checkUncheckChild($event);" id="{{d2.DeliveryConstructType}}" name="dc">
                              <span></span>
                            </label>
                          </a>
                          <div class="iom-sidebar-nav-cont iom-sidebar-nav-link iom-sidebar-child show">
                            <div *ngFor="let d3 of d2.Children" class="iom-sidebar-body">
                              <a href="javascript:;" (click)="dispalyChaild($event);" title='Delivery Construct Type: {{d3.DeliveryConstructType}}'
                                 class="iom-sidebar-nav iom-sidebar-nav-toggle open active">
                                <img src="assets/images/automation.svg" alt=""> <span class="iom-menu-item-name">{{d3.DeliveryConstruct}}</span>
                                <label  [ngClass]="{chkdisabled: d3.DeliveryConstructType == 'DS'}" title="{{ d3.DeliveryConstructType == 'DS' ? 'Cannot create deepdive at this level' : ''}}"  class="myw-checkbox">
                                  <input class="chkbox" type="checkbox"
                                         value='{{d3.DeliveryConstruct + "~^~" + d3.DeliveryConstructUId + "~^~" + d3.DeliveryConstructType + "~^~" + d3.ParentDeliveryConstructType + "~^~" + d3.ParentDeliveryConstructUId + "~^~" + d3.Status + "~^~" + d3.Domain + "~^~" + d3.ParentE2EUID}}'
                                         (click)="checkUncheckChild($event);" id="{{d3.DeliveryConstructType}}" name="dc">
                                  <span></span>
                                </label>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="treeDataParent && (envVar.Env == 'FDS_ManualUpload' || envVar.Env == 'SAAS_ManualUpload') && this.SessionService.getSessionStorageItem('userType') == '3'" class="iom-sidebar" style="overflow: auto;height: 320px;">
						<div class="iom-sidebar-nav-list">
							<a href="javascript:;" (click)="dispalyChaild($event);"
								class="iom-sidebar-parent iom-sidebar-nav iom-sidebar-nav-toggle open active">
								<img src="assets/images/automation.svg" alt="" class="iom-active-parent"> <span
									title="{{getToltipForTree(treeDataParent['DeliveryConstructType'],treeDataParent['WorkstreamTypeID'])}}"
									class="iom-menu-item-name">{{treeDataParent.DeliveryConstruct}}</span>
								<label [ngClass]="{chkdisabled: treeDataParent['DeliveryConstructType'] == 'CMS'}"
									title="{{ treeDataParent['DeliveryConstructType'] == 'CMS' ? 'Cannot create deepdive at this level' : ''}}"
									class="myw-checkbox">
									<input class="chkbox" type="checkbox"
										value='{{treeDataParent["DeliveryConstruct"] + "~^~" + treeDataParent["DeliveryConstructUId"] + "~^~" + treeDataParent["DeliveryConstructType"] + "~^~" + treeDataParent["ParentDeliveryConstructType"] + "~^~" + treeDataParent["ParentDeliveryConstructUId"] + "~^~" + treeDataParent["Status"] + "~^~" + treeDataParent["Domain"] + "~^~" + treeDataParent["WorkstreamTypeID"]}}'
										(click)="checkUncheckChild($event);"
										id="{{treeDataParent['DeliveryConstructType']}}" name="dc">
									<span></span>
								</label>
							</a>
							<div class="iom-sidebar-nav-cont iom-sidebar-nav-link iom-sidebar-child show">
								<div *ngFor="let d of treeData" class="iom-sidebar-body">
									<a href="javascript:;" (click)="dispalyChaild($event);"
										title="{{getToltipForTree(d.DeliveryConstructType,d.WorkstreamTypeID)}}"
										class="iom-sidebar-nav iom-sidebar-nav-toggle open active">
										<img src="assets/images/automation.svg" alt=""> <span
											class="iom-menu-item-name">
											{{d.DeliveryConstruct}}</span>
										<label [ngClass]="{chkdisabled: d.DeliveryConstructType == 'CMS'}"
											title="{{ d.DeliveryConstructType == 'CMS' ? 'Cannot create deepdive at this level' : ''}}"
											class="myw-checkbox">
											<input class="chkbox" type="checkbox"
												value='{{d.DeliveryConstruct + "~^~" + d.DeliveryConstructUId + "~^~" + d.DeliveryConstructType + "~^~" + d.ParentDeliveryConstructType + "~^~" + d.ParentDeliveryConstructUId + "~^~" + d.Status + "~^~" + d.Domain + "~^~" + d.WorkstreamTypeID}}'
												(click)="checkUncheckChild($event);" id="{{d.DeliveryConstructType}}"
												name="dc">
											<span></span>
										</label>
									</a>
									<div class="iom-sidebar-nav-cont iom-sidebar-nav-link iom-sidebar-child show">
										<div *ngFor="let d1 of d.Children" class="iom-sidebar-body">
											<a href="javascript:;" (click)="dispalyChaild($event);"
												title="{{getToltipForTree(d1.DeliveryConstructType,d1.WorkstreamTypeID)}}"
												class="iom-sidebar-nav iom-sidebar-nav-toggle open active">
												<img src="assets/images/automation.svg" alt=""> <span
													class="iom-menu-item-name">{{d1.DeliveryConstruct}}</span>
												<label [ngClass]="{chkdisabled: d1.DeliveryConstructType == 'CMS'}"
													title="{{ d1.DeliveryConstructType == 'CMS' ? 'Cannot create deepdive at this level' : ''}}"
													class="myw-checkbox">
													<input class="chkbox" type="checkbox"
														value='{{d1.DeliveryConstruct + "~^~" + d1.DeliveryConstructUId + "~^~" + d1.DeliveryConstructType + "~^~" + d1.ParentDeliveryConstructType + "~^~" + d1.ParentDeliveryConstructUId + "~^~" + d1.Status + "~^~" + d1.Domain + "~^~" + d1.WorkstreamTypeID}}'
														(click)="checkUncheckChild($event);"
														id="{{d1.DeliveryConstructType}}" name="dc">
													<span></span>
												</label>
											</a>
											<div
												class="iom-sidebar-nav-cont iom-sidebar-nav-link iom-sidebar-child show">
												<div *ngFor="let d2 of d1.Children" class="iom-sidebar-body">
													<a href="javascript:;" (click)="dispalyChaild($event);"
														title="{{getToltipForTree(d2.DeliveryConstructType,d2.WorkstreamTypeID)}}"
														class="iom-sidebar-nav iom-sidebar-nav-toggle open active">
														<img src="assets/images/automation.svg" alt=""> <span
															class="iom-menu-item-name">{{d2.DeliveryConstruct}}</span>
														<label
															[ngClass]="{chkdisabled: d2.DeliveryConstructType == 'CMS'}"
															title="{{ d2.DeliveryConstructType == 'CMS' ? 'Cannot create deepdive at this level' : ''}}"
															class="myw-checkbox">
															<input class="chkbox" type="checkbox"
																value='{{d2.DeliveryConstruct + "~^~" + d2.DeliveryConstructUId + "~^~" + d2.DeliveryConstructType + "~^~" + d2.ParentDeliveryConstructType + "~^~" + d2.ParentDeliveryConstructUId + "~^~" + d2.Status + "~^~" + d2.Domain + "~^~" + d2.WorkstreamTypeID}}'
																(click)="checkUncheckChild($event);"
																id="{{d2.DeliveryConstructType}}" name="dc">
															<span></span>
														</label>
													</a>
													<div
														class="iom-sidebar-nav-cont iom-sidebar-nav-link iom-sidebar-child show">
														<div *ngFor="let d3 of d2.Children" class="iom-sidebar-body">
															<a href="javascript:;" (click)="dispalyChaild($event);"
																title="{{getToltipForTree(d3.DeliveryConstructType,d3.WorkstreamTypeID)}}"
																class="iom-sidebar-nav iom-sidebar-nav-toggle open active">
																<img src="assets/images/automation.svg" alt=""> <span
																	class="iom-menu-item-name">{{d3.DeliveryConstruct}}</span>
																<label
																	[ngClass]="{chkdisabled: d3.DeliveryConstructType == 'CMS'}"
																	title="{{ d3.DeliveryConstructType == 'CMS' ? 'Cannot create deepdive at this level' : ''}}"
																	class="myw-checkbox">
																	<input class="chkbox" type="checkbox"
																		value='{{d3.DeliveryConstruct + "~^~" + d3.DeliveryConstructUId + "~^~" + d3.DeliveryConstructType + "~^~" + d3.ParentDeliveryConstructType + "~^~" + d3.ParentDeliveryConstructUId + "~^~" + d3.Status + "~^~" + d3.Domain + "~^~" + d3.WorkstreamTypeID}}'
																		(click)="checkUncheckChild($event);"
																		id="{{d3.DeliveryConstructType}}" name="dc">
																	<span></span>
																</label>
															</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
          <!-- /Menu -->
        </div>
      </div>
      <div class="col-9">
        <form autocomplete="off" *ngIf="isDataAvailable" [formGroup]="textConfigFormStandard"
              (ngSubmit)="CreateDeepdiveStandard()">
          <div class="row myw-grid">
            <div class="col">
              <div class="card iom-card">
                <div class="card-header py-3">
                  <h4 class="card-title">Deepdive Configuration</h4>
                  <a href="javascript:;" (click)="checkDCSelection();" class="btn ml-auto btn-secondary" role="button"
                     data-bs-target="#advancedModal">
                    <span class="text-nowrap">Advanced Options</span>
                  </a>
                </div>
                <div class="row myw-grid iom-form iom-comPad">
                  <div class="col-md-5 ">
                    <div class="form-group">
                      <label class="form-label myw-required">Deepdive Name</label>
                      <input type="text" formControlName="deepdiveConfig" class="form-control"
                             placeholder="Enter Deepdive Name" />
                    </div>
                  </div>
                  <div class="col-md-5 offset-md-2">
                    <div *ngIf="envVar.ClientConfiguration.isMultiSelectTicketType == false" class="form-group">
                      <label class="form-label myw-required">Ticket Type</label>
                      <select class="form-control" formControlName="ticketType" (change)="ResetQualifiedDesc()">
                        <option value="Select">Select Ticket Type</option>
                        <option *ngFor="let t of lstTicketType_ao" [value]="t.ServiceType">
                          {{t.TicketType}}
                        </option>
                      </select>
                    </div>
                    <div *ngIf="envVar.ClientConfiguration.isMultiSelectTicketType == true" class="form-group iom-dropdown dropdown dropflat">
                      <label class="form-label myw-required">Ticket Type</label>
                      <a href="javascript:;" class="iom-dropdown-toggle" role="button"
                         title="{{selectedTickettype}}" id="assignmentGroup"
                         data-bs-toggle="dropdown" data-bs-display="static" aria-haspopup="true"
                         aria-expanded="false">
                        <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color:#495057;">
                          {{selectedTickettype}}
                        </div>
                      </a>
                      <div class="dropdown-menu" aria-labelledby="assignmentGroup">
                        <div class="dropdown-body">
                          <div class="iom-dropdown-scroll">
                            <div class="fs-16 mb-2">
                              <label class="myw-checkbox">
                                <input type="checkbox" #selectedAllTicket
                                       (change)="selectAllTicket('AO')"
                                       formControlName="selectAllTicket" />
                                <span>All</span>
                              </label>
                            </div>
                            <div *ngIf="lstTicketType_ao"
                                 class="row myw-grid row-cols-2 row-cols-lg-2">
                              <ng-container *ngFor="let d of lstTicketType_ao; let i = index">
                                <div class="col" *ngIf="d.ServiceType != 'All'" formArrayName="ticketTypeMulti">
                                  <label class="myw-checkbox">
                                    <input type="checkbox"
                                           (change)="selectTicketTypemulti('AO')"
                                           value="d.ServiceType" [formControlName]="i" />
                                    <span>{{d.TicketType}}</span>
                                  </label>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 iom-datepicker">
                    <div class="form-group">
                      <label class="form-label myw-required">Start Date</label>
                      <div class="input-group">
                        <input type="text" formControlName="startDate" class="form-control"
                               placeholder="Select Date" ngbDatepicker #d1="ngbDatepicker" />
                        <div class="input-group-append">
                          <button (click)="d1.toggle()" class="btn" type="button">
                            <img src="assets/images/cal.svg" alt="">
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 offset-md-2 iom-datepicker">
                    <div class="form-group">
                      <label class="form-label myw-required">End Date</label>
                      <div class="input-group">
                        <input type="text" formControlName="endDate" class="form-control"
                               placeholder="Select Date" ngbDatepicker #d2="ngbDatepicker" />
                        <div class="input-group-append">
                          <button (click)="d2.toggle()" class="btn" type="button">
                            <img src="assets/images/cal.svg" alt="">
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5" *ngIf="envVar.EnableLanguage">
                    <div class="form-group  iom-multiselect" [ngClass]="{'disabled': isDisabled == true}">     
                        <label class="form-label myw-required">Ticket Language</label>
                        <ng-multiselect-dropdown class="form-control" [placeholder]="'Select'" [(ngModel)]="selectedLanguagestd"
                        [data]="LanguageList" [settings]="dropdownSettings"
                        (enableCheckAll)="false" 
                        (onSelect)="onItemSelect('stdLanguage',$event)"
                        (onSelectAll)="onItemSelectAll('stdLanguage',$event)"
                        (onDeSelect)="onItemDeSelect('stdLanguage',$event)"
                        (onDeSelectAll)="onItemDeSelectAll('stdLanguage',$event)">
                        </ng-multiselect-dropdown>
                    </div>
                </div>
                <div class="col-md-5 offset-md-2">
                  <div class="form-group">
                    <div class="form-inline mt-4">
                    <label class="myw-checkbox">
                      <input #DQTcheckboxstd id="DQTcheckbox" type="checkbox" 
                      [checked]="EnableDQTStd" 
                  
                      (change)="DQTCheckStd(DQTcheckboxstd.checked)" name="data-check">
                      <span>Data Quality Assessment</span>
                    </label>

                    <label class="myw-checkbox">
                      <input #Lemmacheckboxstd id="Lemmacheckbox" type="checkbox" 
                      [checked]="EnableLemmaStd"
                      [disabled]="LemmaDisableStd"
                      (change)="LemmaCheckStd(Lemmacheckboxstd.checked)" name="data-check">
                      <span>Lemmatization</span>
                    </label>
                    
                    <label *ngIf="envVar.Env == 'SAAS_ManualUpload'" class="myw-checkbox">
                      <input #restrictDDcheckbox id="restrictDDcheckbox" type="checkbox" 
                      [checked]="enableRestrictdd"
                      [disabled]="EnableRestrictDDCreation"                           
                      (change)="RestrictDDCheck(restrictDDcheckbox.checked)" name="data-check">
                      <span>Restrict Multiple Deepdive Creation</span>
                    </label>
                  </div>
                  </div>
                </div>
                <div class="col-md-5">
                <div class="form-group">
                  <label class="form-label myw-required">Classified Based on</label>
                  <a href="javascript:;" class="btn btn-icon" title="Please select an description field having min of 51 tickets with no null values." style="cursor: pointer;">
                    <img src="assets/images/i-icon.svg" alt="Refresh" class="myw-icon myw-18">                      
                    </a>
                  <div class="form-inline mt-2">
                    <select class="form-control" formControlName="ClassifiedBased"
                    (change)="GetQualifiedDescription('NA')">
                      <option value="Select">Select</option>
                      <option *ngFor="let t of lstClassifiedBy" [value]="t.name">
                        {{ t.name }}
                      </option>
                    </select>
                  </div>
                </div>
                </div>
                </div>
                <div class="card-footer text-right my-4 d-flex justify-content-end" style="min-height: 0px !important;">
                  <!-- <a class="btn btn-primary link" (click)="navigateToDeepDive()" style="cursor: pointer;">Create
                   Deepdive</a> -->
                  <button type="button" class="btn btn-secondary mr-3"
                          (click)="CancelTicketUpload()" style="cursor: pointer; width: 7rem;">
                    Cancel
                  </button>
                  <button type="submit" class="btn btn-primary link" style="cursor: pointer; width: 7rem;">
                    Create
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>



<div class="modal" id="advancedModal" (click)="HideCheckboxPopup();" tabindex="-1" role="dialog" aria-labelledby="advancedOptions" aria-hidden="true"
     data-bs-backdrop="static">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
    <div class="modal-content iom-modewhite iom-modal-newcnt">
      <div class="modal-header border-0">
        <h5 class="modal-title" id="advancedModal">Advance Options</h5>
        <button id="btnAdvanceClose" type="button" data-bs-dismiss="modal" hidden></button>
        <button type="button" class="close" (click)="unloadDOM();" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>      
        <div class="modal-body adv-modal">
          <div *ngIf="isAvanced" class="select-domain">
            <form autocomplete="off" *ngIf="isDataAvailable" [formGroup]="textConfigForm" (ngSubmit)="CreateDeepdive()">
            <div class="form-group mb-3">
              <label class="form-label fs-16">Select Domain</label>
              <div class="form-inline mt-3 domain-check" formArrayName="domainOption">
                  <label class="myw-checkbox mr-5"
                         *ngFor="let option of textConfigForm.get('domainOption')['controls']; let i=index">
                    <input type="checkbox" (change)="SelectDoamin()" value="lstDomainOption[i].name"
                           [formControlName]="i" />
                    <span class="apps-check fs-16" *ngIf="lstDomainOption[i].name == 'AO'">APP</span>
                    <span class="infra-check fs-16" *ngIf="lstDomainOption[i].name == 'IO'">INFRA</span>
                    <span class="other-check fs-16" *ngIf="lstDomainOption[i].name == 'Others'">OTHERS</span>
                  </label>
              </div>
            </div>
            <div class="nav nav-pills iom-tabs" role="tablist">
              <a *ngIf="enableAo" (click)="loadAoPill()" [ngClass]="{active: isLoadAoPill}"
                 style="cursor: pointer;" class="nav-item nav-link active" id="ao-tab" role="tab"
                 data-bs-toggle="tab" aria-controls="ao" aria-selected="true">APP</a>
              <a *ngIf="enableIo" (click)="loadIoPill()" [ngClass]="{active: isLoadIoPill}"
                 style="cursor: pointer;" class="nav-item nav-link" id="io-tab" role="tab"
                 data-bs-toggle="tab" aria-controls="io" aria-selected="false">INFRA</a>
              <a *ngIf="enableOthers" (click)="loadOtherPill()" [ngClass]="{active: isLoadOtherPill}"
                 style="cursor: pointer;" class="nav-item nav-link" id="other-tab" role="tab"
                 data-bs-toggle="tab" aria-controls="other" aria-selected="false">OTHERS</a>
            </div>
            <div class="tab-content iom-tab-content">
              <!-- AO -->
              <div formGroupName="AOGroup" class="tab-pane show active" id="apps" role="tabpanel"
                   aria-labelledby="apps-tab" [ngClass]="{active: isLoadAoPill}">
                <div class="row iom-form">
                  <div class="col-md-5">
                    <div class="form-group">
                      <label class="form-label myw-required">Deepdive Name</label>
                      <input type="text" formControlName="deepdiveConfig" class="form-control"
                             placeholder="Enter Deepdive Name" />
                    </div>
                  </div>
                  <div class="col-md-5 offset-md-2">
                    <div *ngIf="envVar.ClientConfiguration.isMultiSelectTicketType == false" class="form-group">
                      <label class="form-label myw-required">Ticket Type</label>
                      <select class="form-control" (change)="getStopKeyWords('AO', $event, true)" formControlName="ticketType">
                        <option value="Select">Select Ticket Type</option>
                        <option *ngFor="let t of lstTicketType_ao" [value]="t.ServiceType">
                          {{t.TicketType}}
                        </option>
                      </select>
                    </div>
                    <div *ngIf="envVar.ClientConfiguration.isMultiSelectTicketType == true" class="form-group iom-dropdown dropdown dropflat">
                      <label class="form-label myw-required">Ticket Type</label>
                      <a href="javascript:;" class="iom-dropdown-toggle" role="button"
                      (click)="ShowCheckboxPopup('ao');"
                         title="{{selectedTickettypeadv_ao}}" id="assignmentGroup"
                         data-bs-toggle="dropdown" data-display="static" aria-haspopup="true"
                         aria-expanded="false">
                        <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color:#495057;">
                          {{selectedTickettypeadv_ao}}
                        </div>
                      </a>
                      <div class="dropdown-menu" aria-labelledby="assignmentGroup">
                        <div class="dropdown-body">
                          <div class="iom-dropdown-scroll">
                            <div class="fs-16 mb-2">
                              <label class="myw-checkbox">
                                <input type="checkbox" #selectedAllTicketadv
                                       (change)="selectAllTicketadv('AO')"
                                       formControlName="selectAllTicketadv" />
                                <span>All</span>
                              </label>
                            </div>
                            <div *ngIf="lstTicketType_ao"
                                 class="row myw-grid row-cols-2 row-cols-lg-2">
                              <ng-container *ngFor="let d of lstTicketType_ao; let i = index">
                                <div class="col" *ngIf="d.ServiceType != 'All'" formArrayName="ticketTypeMulti">
                                  <label class="myw-checkbox">
                                    <input type="checkbox"
                                           (change)="selectTicketTypemultiadv('AO')"
                                           value="d.ServiceType" [formControlName]="i" />
                                    <span>{{d.TicketType}}</span>
                                  </label>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 iom-datepicker">
                    <div class="form-group">
                      <label class="form-label myw-required">Start Date</label>
                      <div class="input-group">
                        <input type="text" formControlName="startDate" class="form-control"
                          placeholder="Select Date" ngbDatepicker #d1="ngbDatepicker" onkeydown="return false"
                          (keyup.backspace)="onDateSelected('AO', $event)"
                          (dateSelect)="onDateSelected('AO', $event)" />
                        <div class="input-group-append">
                          <button (click)="d1.toggle()" class="btn" type="button">
                            <img src="assets/images/cal.svg" alt="" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 offset-md-2 iom-datepicker">
                    <div class="form-group">
                      <label class="form-label myw-required">End Date</label>
                      <div class="input-group">
                        <input type="text" formControlName="endDate" class="form-control"
                          placeholder="Select Date" ngbDatepicker #d2="ngbDatepicker" onkeydown="return false"
                          (keyup.backspace)="onDateSelected('AO', $event)"
                          (dateSelect)="onDateSelected('AO', $event)" />
                        <div class="input-group-append">
                          <button (click)="d2.toggle()" class="btn" type="button">
                            <img src="assets/images/cal.svg" alt="" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <label class="form-label myw-required">
                        Select
                        {{envVar.ClientConfiguration.MappingFilterName}}
                      </label>
                      <div class="iom-dropdown dropdown dropflat newao">
                              <a href="javascript:;" (click)="ShowCheckboxPopup('ao');" class="iom-dropdown-toggle"
			role="button" title="{{selectedSupportGroup_AO}}" id="assignmentGroup"
                           data-bs-toggle="dropdown" data-bs-display="static" aria-haspopup="true"
                                aria-expanded="false">
                          <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color: #495057;">
                            {{selectedSupportGroup_AO}}
                          </div>
                        </a>
                        <div class="dropdown-menu" aria-labelledby="assignmentGroup">
                                <div class="new">
                          <div class="dropdown-body">
                            <div class="d-flex justify-content-end iom-dropdown-search">
                              <div class="text-right mt-4">
                                <a href="javascript:;" (click)="loadSupportGrpName('ao')" class="btn btn-primary supportgrp-optnext"
                                  style="width: 7 rem">Select
                                  {{envVar.ClientConfiguration.MappingFilterName}}</a>
                              </div>
                            </div>
                            <div class="iom-dropdown-scroll">
                              <div *ngIf="aoArr"
                                   class="row myw-grid row-cols-2 row-cols-lg-2">
                                <ng-container *ngFor="let d of aoArr; let i = index">
                                  <div class="col" formArrayName="mappingConfigs"
                                       *ngIf="d.name != 'All'">
                                    <label class="my-width" title="{{d.fullName}}">
                                      <span>• {{d.name}}</span>
                                    </label>
                                  </div>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                  <div class="col-md-5 offset-md-2">
                    <div [ngClass]="{'disabled':!categorizedByFlag_ao}" class="form-group">
                      <label class="form-label">Categorised by</label>
                      <select class="form-control" formControlName="categorisedBy">
                        <option value="">Select</option>
                        <option *ngFor="let t of lstCategorisedBy_ao" [value]="t.name">
                          {{t.name}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-5" *ngIf="envVar.EnableLanguage">
                    <div class="form-group  iom-multiselect" [ngClass]="{'disabled': isDisabled == true}">     
                        <label class="form-label myw-required">Ticket Language</label>
                        <ng-multiselect-dropdown formControlName="ddlMultiselect" class="form-control" [placeholder]="'Select'" [(ngModel)]="selectedLanguageAO"
                              [data]="LanguageList" [settings]="dropdownSettings"
                              (enableCheckAll)="false" 
                              (onSelect)="onItemSelect('LanguageAO',$event)"
                              (onSelectAll)="onItemSelectAll('LanguageAO',$event)"
                              (onDeSelect)="onItemDeSelect('LanguageAO',$event)"
                              (onDeSelectAll)="onItemDeSelectAll('LanguageAO',$event)">
                        </ng-multiselect-dropdown>
                    </div>
                </div>
                <div class="col-md-5 offset-md-2">
                  <div class="form-group">                           
                    <label class="myw-checkbox">
                      <input  #DQTCheckboxAO id="DQTcheckboxAO" type="checkbox"
                      [checked]="EnableDQTAO"
                  
                  (change)="DQTCheckAdv(DQTCheckboxAO.checked,'AO')" name="data-qa">
                      <span>Data Quality Assessment</span>
                    </label>  

                    <label class="myw-checkbox">
                      <input  #LemmaCheckboxAO id="LemmaCheckboxAO" type="checkbox"
                      [checked]="EnableLemmaAO"
                      [disabled]="LemmaDisableAO"
                  (change)="LemmaCheckAdv(LemmaCheckboxAO.checked,'AO')" name="data-qa">
                      <span>Lemmatization</span>
                    </label>                     
                  </div>
                </div>
                  <div class="col-12">
                    <div class="form-group">
                      <div class="d-flex justify-content-between">
                      <label class="form-label">Select Algorithm Model</label>
                     
                      </div>
                      <div class="form-inline mt-2">
                        <label class="myw-checkbox myw-radio">
                          <input (click)="algorithmChange(true,'ao', false, true, true,'')"
                                 type="radio" value="2" formControlName="algorithmModel"
                                 checked />
                          <span>Auto Categorization (K-means)</span>
                        </label>
                        <label class="myw-checkbox myw-radio">
                          <input (click)="algorithmChange(false,'ao', true, true, true,'')"
                                 type="radio" value="1" formControlName="algorithmModel" />
                          <span>User Defined (N-gram)</span>
                        </label>
                        <!-- <label *ngIf="!InstancePAM" class="myw-checkbox myw-radio">
                          <input [attr.disabled]="InstancePAM? 'disabled' : null" (click)="algorithmChange(false,'ao', false, true, true,'')"
                                 type="radio" value="4" formControlName="algorithmModel" />
                          <span>SAP Classification</span>
                        </label> -->
                      </div>
                    </div>
                  </div>
                 
                  <div [ngClass]="{'disabled':!selectedAlgoOption}" *ngIf="this.required_ao == false" class="col-md-5">
                    <div class="form-group">
                      <label class="form-label">No of Cluster</label>
                      <input type="text" [readonly]="!selectedAlgoOption"
                             formControlName="noOfCluster" class="form-control"
                             placeholder="Enter the Number of Cluster" />
                    </div>
                  </div>
                  <div [ngClass]="{'disabled':!selectedAlgoOption}" *ngIf="this.required_ao == true" class="col-md-5">
                    <div class="form-group">
                      <label class="form-label myw-required">No of Cluster</label>
                      <input type="text" [readonly]="!selectedAlgoOption"
                             formControlName="noOfCluster" class="form-control"
                             placeholder="Enter the Number of Cluster" />
                    </div>
                  </div>
                  <div [ngClass]="{'disabled':!selectedAlgoOption}"  *ngIf="this.required_ao == false" class="col-md-5 offset-md-2" style="padding-left: 0px">
                    <div class="form-group">
                      <label class="form-label">
                        Allow max % of unclassified tickets
                      </label>
                      <input type="text" [readonly]="!selectedAlgoOption"
                             formControlName="exitCriteria" class="form-control"
                             placeholder="Enter allow max % of unclassified tickets" />
                    </div>
                  </div>
                  <div [ngClass]="{'disabled':!selectedAlgoOption}"  *ngIf="this.required_ao == true" class="col-md-5 offset-md-2" style="padding-left: 0px">
                    <div class="form-group">
                      <label class="form-label myw-required">
                        Allow max % of unclassified tickets
                      </label>
                      <input type="text" [readonly]="!selectedAlgoOption"
                             formControlName="exitCriteria" class="form-control"
                             placeholder="Enter allow max % of unclassified tickets" />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label class="form-label myw-required">Classified Based on</label>
                      <a href="javascript:;" class="btn btn-icon" title="Please select an description field having min of 51 tickets with no null values." style="cursor: pointer;">
                        <img src="assets/images/i-icon.svg" alt="Refresh" class="myw-icon myw-18">                      
                        </a> 
                      <div class="form-inline mt-2">
                        <select class="form-control" formControlName="ClassifiedBased"
                        (change)="GetQualifiedDescription('AO')">
                          <option value="Select">Select</option>
                          <option *ngFor="let t of lstClassifiedBy_ao" [value]="t.name">
                            {{ t.name }}
                          </option>
                        </select>
												<!-- <label class="myw-checkbox myw-radio">
													<input (click)="ClassifiedBasedONChange('Short Description','AO')" type="radio"
														value="Short Description" formControlName="classifiedBasedOn"
														checked />
													<span>Short Description</span>
												</label>
												<label class="myw-checkbox myw-radio">
													<input
														[attr.disabled]="!isResolutionDescEnabled_AO || !isResolutionDescEnabledTask_AO? 'disabled' : null"
														(click)="ClassifiedBasedONChange('Resolution Description','AO')" type="radio"
														value="Resolution Description"
														formControlName="classifiedBasedOn" />
													<span>Resolution Description</span>
												</label> -->
												<!-- <label class="myw-checkbox myw-radio">
													<input
														[attr.disabled]="!isLongDescEnabled_AO? 'disabled' : null"
														(click)="ClassifiedBasedONChange('Long Description','AO')" type="radio"
														value="Long Description"
														formControlName="classifiedBasedOn" />
													<span>Long Description</span>
												</label> -->
                        <div class="d-flex align-items-end ml-lg-auto mb-2">
                          Click here to&nbsp;<a href="javascript:;"
                            (click)="getTopKeyWords('AO',true);" title='If any filter are modified, please click on "get top keywords" to get the updated word cloud chart.'>
                            Get top keywords</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="ChartData_AO" class="col-12">
										<div class="iom-keyword">
											<div class="d-flex align-items-end justify-content-end align-items-center">
												<div class="form-inline mr-2">
													<select class="form-control control-border" (change)="getTopKeyWords('AO',false)"
													formControlName="topWordOption">
													<option *ngFor="let t of WordCloudFilterOptions" [value]="t">Top {{t}} words</option>
												  </select>
												</div>
												<!-- <a href="javascript:;" title="Minus"><img src="images/key-minus.svg" alt="Minus" class="myw-icon myw-40 mr-n2"></a>
													<a href="javascript:;" title="Plus"><img src="images/key-plus.svg" alt="Plus" class="myw-icon myw-40"></a> -->
											</div>
											<div class="card-body" id="wordcloudContent">
												<div id="containerwordCloud_AO">
													<app-word-chart [ContainerId]="containerwordCloud_AO"
														[GraphData]="ChartData_AO" [wordlength]=1></app-word-chart>
												</div>
											</div>
										</div>
									</div>
                  <!-- <div *ngIf="envVar.ClientConfiguration.isDisplayAppName == true && !InstancePAM" class="col-md-5">
                    <div *ngIf="envVar.ClientConfiguration.isMultiSelectAppName == false" class="form-group">
                      <label class="form-label myw-required">Application Name</label>
                      <select class="form-control" formControlName="applicationType">
                        <option value="Select">Select</option>
                        <option *ngFor="let t of lstapplication_ao" [value]="t.name">
                          {{t.displayName}}
                        </option>
                      </select>
                    </div>
                    <div *ngIf="envVar.ClientConfiguration.isMultiSelectAppName == true && !InstancePAM"class="form-group iom-dropdown dropdown dropflat">
                      <label class="form-label myw-required">Application Name</label>
                      <a href="javascript:;" class="iom-dropdown-toggle" role="button"
                         title="{{selectedapplication_ao}}" id="assignmentGroup"
                         data-bs-toggle="dropdown" data-bs-display="static" aria-haspopup="true"
                         aria-expanded="false">
                        <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color: #495057;">
                          {{selectedapplication_ao}}
                        </div>
                      </a>
                      <div class="dropdown-menu" aria-labelledby="assignmentGroup">
                        <div class="dropdown-body">
                          <div class="iom-dropdown-scroll">
                            <div class="fs-16 mb-2">
                              <label class="myw-checkbox">
                                <input type="checkbox" #selectedAllApplication
                                       (change)="selectAllApplication('AO')"
                                       formControlName="selectAllApplication" />
                                <span>All</span>
                              </label>
                            </div>
                            <div *ngIf="lstapplication_ao"
                                 class="row myw-grid row-cols-2 row-cols-lg-2">
                              <ng-container *ngFor="let d of lstapplication_ao; let i = index">
                                <div class="col" *ngIf="d.name != 'All'" formArrayName="applicationType">
                                  <label class="myw-checkbox">
                                    <input type="checkbox"
                                           (change)="selectApplication('AO')"
                                           value="d.name" [formControlName]="i" />
                                    <span>{{d.displayName}}</span>
                                  </label>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <div *ngIf="envVar.ClientConfiguration.isDisplayAppName == false" class="col-md-5">
                  </div>
                  
                  <div class="col" *ngIf="isAddkeywordsEnabled_AO">
                    <div class="form-group">
                      <label class="form-label">Add/Delete Stopwords</label>
                      <div class="form-group iom-multiselect">
                        <label>Language : </label>
                        <select class="form-control" style="width: 200px" [(ngModel)]='selectedStdLanguageAO' formControlName="ignorekeywordLanguage"
                                            (change)="GetSelectedLanguage($event,'ao')">
                                            <option value="Select">Select</option>
                                                <option *ngFor="let t of selectedLanguage_AO"
                                                    [value]="t">
                                                    {{t}}</option>
                                            </select>
                        </div>
                      <input type="text" formControlName="ignorekeyword" class="form-control"
                             name="ignoreword" placeholder="Enter Keyword" />
                    </div>
                  </div>
                  <div class="col-auto d-flex align-items-end" *ngIf="isAddkeywordsEnabled_AO">
                    <div class="form-group">
                      <button type="button" (click)="addIgnoreKeyword('ao')"
                              class="btn btn-primary">
                        Add
                      </button>
                    </div>
                  </div>
                  <div class="col-12" *ngIf="isAddkeywordsEnabled_AO && enableBox_AO">
                    <div class="form-group mb-0">
                      <div rows="4">
                        <span class="tag-item" *ngFor="let word of lstIgnoreKeys" name="tagKey">
                          {{word}}
                          <span class="remove-tag" (click)="RemoveKeyword(word,'ao')"
                                style="cursor: pointer;">×</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- IO -->
              <div formGroupName="IOGroup" class="tab-pane" id="infra" role="tabpanel"
                   aria-labelledby="infra-tab" [ngClass]="{active: isLoadIoPill}">
                <div class="row iom-form">
                  <div class="col-md-5">
                    <div class="form-group">
                      <label class="form-label myw-required">Deepdive Name</label>
                      <input type="text" formControlName="deepdiveConfig" class="form-control"
                             placeholder="Enter Deepdive Name" />
                    </div>
                  </div>
                  <!-- <div class="col-md-5 offset-md-2">
                    <div class="form-group">
                      <label class="form-label myw-required">Ticket Type</label>
                      <select class="form-control" formControlName="ticketType">
                        <option value="Select">Select Ticket Type</option>
                        <option *ngFor="let t of lstTicketType_io" [value]="t.ServiceType">
                          {{t.TicketType}}
                        </option>
                      </select>
                    </div>
                  </div> -->
                  <div class="col-md-5 offset-md-2">
                    <div *ngIf="envVar.ClientConfiguration.isMultiSelectTicketType == false" class="form-group">
                      <label class="form-label myw-required">Ticket Type</label>
                      <select class="form-control" (change)="getStopKeyWords('IO', $event, true)" formControlName="ticketType">
                        <option value="Select">Select Ticket Type</option>
                        <option *ngFor="let t of lstTicketType_io" [value]="t.ServiceType">
                          {{t.TicketType}}
                        </option>
                      </select>
                    </div>
                    <div *ngIf="envVar.ClientConfiguration.isMultiSelectTicketType == true" class="form-group iom-dropdown dropdown dropflat">
                      <label class="form-label myw-required">Ticket Type</label>
                      <a href="javascript:;" class="iom-dropdown-toggle" role="button"
                      (click)="ShowCheckboxPopup('io');"
                         title="{{selectedTickettypeadv_io}}" id="assignmentGroup"
                         data-bs-toggle="dropdown" data-bs-display="static" aria-haspopup="true"
                         aria-expanded="false">
                        <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color:#495057;">
                          {{selectedTickettypeadv_io}}
                        </div>
                      </a>
                      <div class="dropdown-menu" aria-labelledby="assignmentGroup">
                        <div class="dropdown-body">
                          <div class="iom-dropdown-scroll">
                            <div class="fs-16 mb-2">
                              <label class="myw-checkbox">
                                <input type="checkbox" #selectedAllTicketadv
                                       (change)="selectAllTicketadv('IO')"
                                       formControlName="selectAllTicketadv" />
                                <span>All</span>
                              </label>
                            </div>
                            <div *ngIf="lstTicketType_io"
                                 class="row myw-grid row-cols-2 row-cols-lg-2">
                              <ng-container *ngFor="let d of lstTicketType_io; let i = index">
                                <div class="col" *ngIf="d.ServiceType != 'All'" formArrayName="ticketTypeMulti">
                                  <label class="myw-checkbox">
                                    <input type="checkbox"
                                           (change)="selectTicketTypemultiadv('IO')"
                                           value="d.ServiceType" [formControlName]="i" />
                                    <span>{{d.TicketType}}</span>
                                  </label>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 iom-datepicker">
                    <div class="form-group">
                      <label class="form-label myw-required">Start Date</label>
                      <div class="input-group">
                        <input type="text" formControlName="startDate" class="form-control"
                                placeholder="Select Date" ngbDatepicker #d3="ngbDatepicker" onkeydown="return false"
                                (keyup.backspace)="onDateSelected('IO', $event)"
                                (dateSelect)="onDateSelected('IO', $event)" />
                              <div class="input-group-append">
                                <button (click)="d3.toggle()" class="btn" type="button">
                                  <img src="assets/images/cal.svg" alt="" />
                                </button>
                              </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 offset-md-2 iom-datepicker">
                    <div class="form-group">
                      <label class="form-label myw-required">End Date</label>
                      <div class="input-group">
                        <input type="text" formControlName="endDate" class="form-control"
                                placeholder="Select Date" ngbDatepicker #d4="ngbDatepicker" onkeydown="return false"
                                (keyup.backspace)="onDateSelected('IO', $event)"
                                (dateSelect)="onDateSelected('IO', $event)" />
                        <div class="input-group-append">
                          <button (click)="d4.toggle()" class="btn" type="button">
                                  <img src="assets/images/cal.svg" alt="" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <label class="form-label myw-required">Select
                        {{envVar.ClientConfiguration.MappingFilterName}}</label>
                      <div class="iom-dropdown dropdown dropflat newio">
                              <a href="javascript:;" (click)="ShowCheckboxPopup('io');" class="iom-dropdown-toggle"
                                role="button" title=" {{ selectedSupportGroup_IO }}" id="assignmentGroup"
                           data-bs-toggle="dropdown" data-bs-display="static" aria-haspopup="true"
                                aria-expanded="false">
                          <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color: #495057;">
                            {{selectedSupportGroup_IO}}
                          </div>
                        </a>
                              <div id="assignmentGroup_ao" class="dropdown-menu" aria-labelledby="assignmentGroup">
                                <div class="new">
                          <div class="dropdown-body">
                            <div class="d-flex justify-content-end iom-dropdown-search">
                              <div class="text-right mt-4">
                                <a href="javascript:;" (click)="loadSupportGrpName('io')" class="btn btn-primary supportgrp-optnext"
                                  style="width: 7 rem">Select
                                  {{envVar.ClientConfiguration.MappingFilterName}}</a>
                              </div>
                            </div>
                            <div class="iom-dropdown-scroll">
                              <div *ngIf="ioArr"
                                   class="row myw-grid row-cols-2 row-cols-lg-2">
                                <ng-container *ngFor="let d of ioArr; let i = index">
                                  <div class="col" formArrayName="mappingConfigs"
                                       *ngIf="d.name != 'All'">
                                    <label class="my-width" title="{{d.fullName}}">
                                      <span>• {{d.name}}</span>
                                    </label>
                                  </div>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                  <div class="col-md-5 offset-md-2">
                    <div [ngClass]="{'disabled':!categorizedByFlag_io}" class="form-group">
                      <label class="form-label">Categorised by</label>
                      <select class="form-control" formControlName="categorisedBy">
                        <option value="">Select</option>
                        <option *ngFor="let t of lstCategorisedBy_io" [value]="t.name">
                          {{t.name}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-5" *ngIf="envVar.EnableLanguage">
                    <div class="form-group iom-multiselect" [ngClass]="{'disabled': isDisabled == true}">     
                        <label class="form-label myw-required">Ticket Language</label>
                        <ng-multiselect-dropdown formControlName="ddlMultiselect" class="form-control" [placeholder]="'Select'" [(ngModel)]="selectedLanguageIO"
                        [data]="LanguageList" [settings]="dropdownSettings"
                        (enableCheckAll)="false" 
                        (onSelect)="onItemSelect('LanguageIO',$event)"
                        (onSelectAll)="onItemSelectAll('LanguageIO',$event)"
                        (onDeSelect)="onItemDeSelect('LanguageIO',$event)"
                        (onDeSelectAll)="onItemDeSelectAll('LanguageIO',$event)">
                  </ng-multiselect-dropdown>
                    </div>
                </div>
                <div class="col-md-5 offset-md-2">
                  <div class="form-group">                           
                    <label class="myw-checkbox">
                      <input  #DQTCheckboxIO id="DQTcheckboxIO" type="checkbox" 
                      [checked]="EnableDQTIO"
                     
                        (change)="DQTCheckAdv(DQTCheckboxIO.checked,'IO')"  name="data-qi">
                      <span>Data Quality Assessment</span>
                    </label>   
                    
                    <label class="myw-checkbox">
                      <input  #LemmaCheckboxIO id="LemmaCheckboxIO" type="checkbox" 
                      [checked]="EnableLemmaIO"
                      [disabled]="LemmaDisableIO"
                        (change)="LemmaCheckAdv(LemmaCheckboxIO.checked,'IO')"  name="data-qi">
                      <span>Lemmatization</span>
                    </label>  
                  </div>
                </div>
                  <div class="col-12">
                    <div class="form-group">
                      <div class="d-flex justify-content-between">  
                      <label class="form-label">Select Algorithm Model</label>
                     
                      </div>
                      <div class="form-inline mt-2">
                        <label class="myw-checkbox myw-radio">
                          <input (click)="algorithmChange(true,'io', false, true, true,'')"
                                 type="radio" value="2" formControlName="algorithmModel"
                                 checked />
                          <span>Auto Categorization (K-means)</span>
                        </label>
                        <label class="myw-checkbox myw-radio">
                          <input (click)="algorithmChange(false,'io', true, true, true,'ngram')"
                                 type="radio" value="1" formControlName="algorithmModel" />
                          <span>User Defined (N-gram)</span>
                        </label>
                        <label class="myw-checkbox myw-radio">
                          <input [attr.disabled]="check_language!='English' ? 'disabled' : null"
                          (click)="algorithmChange(false,'io', false, false, false,'regression')"
                                 type="radio" value="3" formControlName="algorithmModel" />
                          <span>Logistic Regression</span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div [ngClass]="{'disabled':!selectedAlgoOption_io}" *ngIf="this.required_io == false" class="col-md-5">
                    <div class="form-group">
                      <label class="form-label">No of Cluster</label>
                      <input type="text" [readonly]="!selectedAlgoOption_io"
                             formControlName="noOfCluster" class="form-control"
                             placeholder="Enter the Number of Cluster" />
                    </div>
                  </div>
                  <div [ngClass]="{'disabled':!selectedAlgoOption_io}" *ngIf="this.required_io == true" class="col-md-5">
                    <div class="form-group">
                      <label class="form-label myw-required">No of Cluster</label>
                      <input type="text" [readonly]="!selectedAlgoOption_io"
                             formControlName="noOfCluster" class="form-control"
                             placeholder="Enter the Number of Cluster" />
                    </div>
                  </div>
                  <div [ngClass]="{'disabled':!selectedAlgoOption_io}" *ngIf="this.required_io == false" class="col-md-5 offset-md-2"
                        style="padding-left: 0px">
                    <div class="form-group">
                      <label class="form-label">
                        Allow max % of unclassified tickets
                      </label>
                      <input type="text" [readonly]="!selectedAlgoOption_io"
                             formControlName="exitCriteria" class="form-control"
                             placeholder="Enter allow max % of unclassified tickets" />
                    </div>
                  </div>
                  <div [ngClass]="{'disabled':!selectedAlgoOption_io}" *ngIf="this.required_io == true" class="col-md-5 offset-md-2"
                        style="padding-left: 0px">
                    <div class="form-group">
                      <label class="form-label myw-required">
                        Allow max % of unclassified tickets
                      </label>
                      <input type="text" [readonly]="!selectedAlgoOption_io"
                             formControlName="exitCriteria" class="form-control"
                             placeholder="Enter allow max % of unclassified tickets" />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label class="form-label myw-required">Classified Based on</label>
                      <a href="javascript:;" class="btn btn-icon" title="Please select an description field having min of 51 tickets with no null values." style="cursor: pointer;">
                        <img src="assets/images/i-icon.svg" alt="Refresh" class="myw-icon myw-18">                      
                        </a> 
                      <div class="form-inline mt-2">
                        <select class="form-control" formControlName="ClassifiedBased"
                        (change)="GetQualifiedDescription('IO')">
                          <option value="Select">Select</option>
                          <option *ngFor="let t of lstClassifiedBy_io" [value]="t.name">
                            {{ t.name }}
                          </option>
                        </select>
												<!-- <label class="myw-checkbox myw-radio">
													<input (click)="ClassifiedBasedONChange('Short Description','IO')" type="radio"
														value="Short Description" formControlName="classifiedBasedOn"
														checked />
													<span>Short Description</span>
												</label>
												<label class="myw-checkbox myw-radio">
													<input
														[attr.disabled]="!isResolutionDescEnabled_IO || !isResolutionDescEnabledTask_IO? 'disabled' : null"
														(click)="ClassifiedBasedONChange('Resolution Description','IO')" type="radio"
														value="Resolution Description"
														formControlName="classifiedBasedOn" />
													<span>Resolution Description</span>
												</label> -->
												<!-- <label class="myw-checkbox myw-radio">
													<input
														[attr.disabled]="!isLongDescEnabled_IO? 'disabled' : null"
														(click)="ClassifiedBasedONChange('Long Description','IO')" type="radio"
														value="Long Description"
														formControlName="classifiedBasedOn" />
													<span>Long Description</span>
												</label> -->
                        <div *ngIf="isAddkeywordsEnabled_IO" class="d-flex align-items-end ml-lg-auto mb-2">
                          Click here to&nbsp;<a href="javascript:;"
                            (click)="getTopKeyWords('IO',true);" title='If any filter are modified, please click on "get top keywords" to get the updated word cloud chart.'>
                            Get top keywords</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="isAddkeywordsEnabled_IO && ChartData_IO" class="col-12">
										<div class="iom-keyword">
											<div class="d-flex align-items-end justify-content-end align-items-center">
												<div class="form-inline mr-2">
													<select class="form-control control-border" (change)="getTopKeyWords('IO',false)"
													formControlName="topWordOption">
													<option *ngFor="let t of WordCloudFilterOptions" [value]="t">Top {{t}} words</option>
												  </select>
												</div>
												<!-- <a href="javascript:;" title="Minus"><img src="images/key-minus.svg" alt="Minus" class="myw-icon myw-40 mr-n2"></a>
													<a href="javascript:;" title="Plus"><img src="images/key-plus.svg" alt="Plus" class="myw-icon myw-40"></a> -->
											</div>
											<div class="card-body" id="wordcloudContent">
												<div id="containerwordCloud_IO">
													<app-word-chart [ContainerId]="containerwordCloud_IO"
														[GraphData]="ChartData_IO" [wordlength]=1></app-word-chart>
												</div>
											</div>
										</div>
									</div>
                  <!-- <div *ngIf="envVar.ClientConfiguration.isDisplayAppName == true && !InstancePAM" class="col-md-5">
                    <div *ngIf="envVar.ClientConfiguration.isMultiSelectAppName == false" class="form-group">
                      <label class="form-label myw-required">Application Name</label>
                      <select class="form-control" formControlName="applicationType">
                        <option value="Select">Select</option>
                        <option *ngFor="let t of lstapplication_io" [value]="t.name">
                          {{t.displayName}}
                        </option>
                      </select>
                    </div>
                    <div *ngIf="envVar.ClientConfiguration.isMultiSelectAppName == true && !InstancePAM"class="form-group iom-dropdown dropdown dropflat">
                      <label class="form-label myw-required">Application Name</label>
                      <a href="javascript:;" class="iom-dropdown-toggle" role="button"
                         title="{{selectedapplication_io}}" id="assignmentGroup"
                         data-bs-toggle="dropdown" data-bs-display="static" aria-haspopup="true"
                         aria-expanded="false">
                        <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color: #495057;">
                          {{selectedapplication_io}}
                        </div>
                      </a>
                      <div class="dropdown-menu" aria-labelledby="assignmentGroup">
                        <div class="dropdown-body">
                          <div class="iom-dropdown-scroll">
                            <div class="fs-16 mb-2">
                              <label class="myw-checkbox">
                                <input type="checkbox" #selectedAllApplication
                                       (change)="selectAllApplication('IO')"
                                       formControlName="selectAllApplication" />
                                <span>All</span>
                              </label>
                            </div>
                            <div *ngIf="lstapplication_io"
                                 class="row myw-grid row-cols-2 row-cols-lg-2">
                              <ng-container *ngFor="let d of lstapplication_io; let i = index">
                                <div class="col" *ngIf="d.name != 'All'" formArrayName="applicationType">
                                  <label class="myw-checkbox">
                                    <input type="checkbox"
                                           (change)="selectApplication('IO')"
                                           value="d.name" [formControlName]="i" />
                                    <span>{{d.displayName}}</span>
                                  </label>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  
                  <div class="col" *ngIf="isAddkeywordsEnabled_IO">
                    <div class="form-group">
                      <label class="form-label">Add/Delete Stopwords</label>
                      <div class="form-group iom-multiselect">
                        <label>Language : </label>
                        <select class="form-control" style="width: 200px" [(ngModel)]='selectedStdLanguageIO' formControlName="ignorekeywordLanguage"
                                            (change)="GetSelectedLanguage($event,'io')">
                                            <option value="Select">Select</option>
                                                <option *ngFor="let t of selectedLanguage_IO"
                                                    [value]="t">
                                                    {{t}}</option>
                                            </select>
                     </div>
                      <input type="text" formControlName="ignorekeyword" class="form-control"
                             name="ignoreword" placeholder="Enter Keyword" />
                    </div>
                  </div>
                  <div class="col-auto d-flex align-items-end" *ngIf="isAddkeywordsEnabled_IO">
                    <div class="form-group">
                      <button type="button" (click)="addIgnoreKeyword('io')"
                              class="btn btn-primary">
                        Add
                      </button>
                    </div>
                  </div>
                  <div class="col-12" *ngIf="isAddkeywordsEnabled_IO && enableBox_IO">
                    <div class="form-group mb-0">
                      <div rows="4">
                        <span class="tag-item" *ngFor="let word of lstIgnoreKeys_io"
                              name="igonorew">
                          {{word}}
                          <span class="remove-tag" (click)="RemoveKeyword(word,'io')"
                                style="cursor: pointer;">×</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Other -->
              <div formGroupName="OthersGroup" class="tab-pane" id="other" role="tabpanel"
                   aria-labelledby="other-tab" [ngClass]="{active: isLoadOtherPill}">
                <div class="row iom-form">
                  <div class="col-md-5">
                    <div class="form-group">
                      <label class="form-label myw-required">Deepdive Name</label>
                      <input type="text" formControlName="deepdiveConfig" class="form-control"
                             placeholder="Enter Deepdive Name" />
                    </div>
                  </div>
                  <!-- <div class="col-md-5 offset-md-2">
                    <div class="form-group">
                      <label class="form-label myw-required">Ticket Type</label>
                      <select class="form-control" formControlName="ticketType">
                        <option value="Select">Select Ticket Type</option>
                        <option *ngFor="let t of lstTicketType_others" [value]="t.ServiceType">
                          {{t.TicketType}}
                        </option>
                      </select>
                    </div>
                  </div> -->
                  <div class="col-md-5 offset-md-2">
                    <div *ngIf="envVar.ClientConfiguration.isMultiSelectTicketType == false" class="form-group">
                      <label class="form-label myw-required">Ticket Type</label>
                      <select class="form-control" (change)="getStopKeyWords('Others', $event, true)" formControlName="ticketType">
                        <option value="Select">Select Ticket Type</option>
                        <option *ngFor="let t of lstTicketType_others" [value]="t.ServiceType">
                          {{t.TicketType}}
                        </option>
                      </select>
                    </div>
                    <div *ngIf="envVar.ClientConfiguration.isMultiSelectTicketType == true" class="form-group iom-dropdown dropdown dropflat">
                      <label class="form-label myw-required">Ticket Type</label>
                      <a href="javascript:;" class="iom-dropdown-toggle" role="button"
                         title="{{selectedTickettypeadv_others}}" id="assignmentGroup"
                         (click)="ShowCheckboxPopup('Others');"
                         data-bs-toggle="dropdown" data-bs-display="static" aria-haspopup="true"
                         aria-expanded="false">
                        <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color:#495057;">
                          {{selectedTickettypeadv_others}}
                        </div>
                      </a>
                      <div class="dropdown-menu" aria-labelledby="assignmentGroup">
                        <div class="dropdown-body">
                          <div class="iom-dropdown-scroll">
                            <div class="fs-16 mb-2">
                              <label class="myw-checkbox">
                                <input type="checkbox" #selectedAllTicketadv
                                       (change)="selectAllTicketadv('Others')"
                                       formControlName="selectAllTicketadv" />
                                <span>All</span>
                              </label>
                            </div>
                            <div *ngIf="lstTicketType_ao"
                                 class="row myw-grid row-cols-2 row-cols-lg-2">
                              <ng-container *ngFor="let d of lstTicketType_ao; let i = index">
                                <div class="col" *ngIf="d.ServiceType != 'All'" formArrayName="ticketTypeMulti">
                                  <label class="myw-checkbox">
                                    <input type="checkbox"
                                           (change)="selectTicketTypemultiadv('Others')"
                                           value="d.ServiceType" [formControlName]="i" />
                                    <span>{{d.TicketType}}</span>
                                  </label>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 iom-datepicker">
                    <div class="form-group">
                      <label class="form-label myw-required">Start Date</label>
                      <div class="input-group">
                        <input type="text" formControlName="startDate" class="form-control"
                          placeholder="Select Date" ngbDatepicker #d5="ngbDatepicker" onkeydown="return false"
                          (keyup.backspace)="
                            onDateSelected('Others', $event)
                          " (dateSelect)="onDateSelected('Others', $event)" />
                        <div class="input-group-append">
                          <button (click)="d5.toggle()" class="btn" type="button">
                            <img src="assets/images/cal.svg" alt="" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 offset-md-2 iom-datepicker">
                    <div class="form-group">
                      <label class="form-label myw-required">End Date</label>
                      <div class="input-group">
                        <input type="text" formControlName="endDate" class="form-control"
                          placeholder="Select Date" ngbDatepicker #d6="ngbDatepicker" onkeydown="return false"
                          (keyup.backspace)="
                            onDateSelected('Others', $event)
                          " (dateSelect)="onDateSelected('Others', $event)" />
                        <div class="input-group-append">
                          <button (click)="d6.toggle()" class="btn" type="button">
                            <img src="assets/images/cal.svg" alt="" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <label class="form-label myw-required">
                        Select
                        {{envVar.ClientConfiguration.MappingFilterName}}
                      </label>
                      <div class="iom-dropdown dropdown dropflat newoth">
                              <a href="javascript:;" (click)="ShowCheckboxPopup('others');" class="iom-dropdown-toggle"
                                role="button" title="{{ selectedSupportGroup_Others }}" id="assignmentGroup"
                           data-bs-toggle="dropdown" data-bs-display="static" aria-haspopup="true"
                                aria-expanded="false">
                          <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color: #495057;">
                            {{selectedSupportGroup_Others}}
                          </div>
                        </a>
                        <div class="dropdown-menu" aria-labelledby="assignmentGroup">
                                <div class="new">
                          <div class="dropdown-body">
                            <div class="d-flex justify-content-end iom-dropdown-search">
                              <div class="text-right mt-4">
                                <a href="javascript:;" (click)="loadSupportGrpName('others')" class="btn btn-primary supportgrp-optnext"
                                  style="width: 7 rem">Select
                                  {{envVar.ClientConfiguration.MappingFilterName}}</a>
                              </div>
                            </div>
                            <div class="iom-dropdown-scroll">
                              <div *ngIf="othArr"
                                   class="row myw-grid row-cols-2 row-cols-lg-2">
                                <ng-container *ngFor="let d of othArr; let i = index">
                                  <div class="col" formArrayName="mappingConfigs"
                                       *ngIf="d.name != 'All'">
                                    <label class="my-width" title="{{d.fullName}}">
                                      <span>• {{d.name}}</span>
                                    </label>
                                  </div>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                  <div class="col-md-5 offset-md-2">
                    <div [ngClass]="{'disabled':!categorizedByFlag_others}" class="form-group">
                      <label class="form-label">Categorised by</label>
                      <select class="form-control" formControlName="categorisedBy">
                        <option value="">Select</option>
                        <option *ngFor="let t of lstCategorisedBy_others" [value]="t.name">
                          {{t.name}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-5" *ngIf="envVar.EnableLanguage">
                    <div class="form-group  iom-multiselect" [ngClass]="{'disabled': isDisabled == true}">     
                        <label class="form-label myw-required">Ticket Language</label>
                        <ng-multiselect-dropdown formControlName="ddlMultiselect" class="form-control" [placeholder]="'Select'" [(ngModel)]="selectedLanguage_Other"
                              [data]="LanguageList" [settings]="dropdownSettings"
                              (enableCheckAll)="false" 
                              (onSelect)="onItemSelect('LanguageOther',$event)"
                              (onSelectAll)="onItemSelectAll('LanguageOther',$event)"
                              (onDeSelect)="onItemDeSelect('LanguageOther',$event)"
                              (onDeSelectAll)="onItemDeSelectAll('LanguageOther',$event)">
                        </ng-multiselect-dropdown>
                    </div>
                </div>
                <div class="col-md-5 offset-md-2">
                  <div class="form-group">                           
                    <label class="myw-checkbox">
                      <input #DQTCheckboxOth id="DQTCheckboxOth" type="checkbox" 
                      [checked]="EnableDQTOth"
                 
              (change)="DQTCheckAdv(DQTCheckboxOth.checked,'Oth')" name="data-qo">
                      <span>Data Quality Assessment</span>
                    </label>   

                    <label class="myw-checkbox">
                      <input #LemmaCheckboxOth id="LemmaCheckboxOth" type="checkbox" 
                      [checked]="EnableLemmaOth"
                      [disabled]="LemmaDisableOth"
              (change)="LemmaCheckAdv(LemmaCheckboxOth.checked,'Oth')" name="data-qo">
                      <span>Lemmatization</span>
                    </label>                         
                  </div>
                </div>
                  <div class="col-12">
                    <div class="form-group">
                      <div class="d-flex justify-content-between">
                      <label class="form-label">Select Algorithm Model</label>                      
                    </div>
                      <div class="form-inline mt-2">
                        <label class="myw-checkbox myw-radio">
                          <input (click)="algorithmChange(true,'others', false, true, true,'')"
                                 type="radio" value="2" formControlName="algorithmModel"
                                 checked />
                          <span>Auto Categorization (K-means)</span>
                        </label>
                        <label class="myw-checkbox myw-radio">
                          <input (click)="algorithmChange(false,'others', true, true, true,'')"
                                 type="radio" value="1" formControlName="algorithmModel" />
                          <span>User Defined (N-gram)</span>
                        </label>
                        <!-- <label *ngIf="!InstancePAM" class="myw-checkbox myw-radio">
                          <input (click)="algorithmChange(false,'others', false, true, true,'')"
                                 type="radio" value="4" formControlName="algorithmModel" />
                          <span>SAP Classification</span>
                        </label> -->
                      </div>
                    </div>
                  </div>
                  <div [ngClass]="{'disabled':!selectedAlgoOption_others}" *ngIf="this.required_others == false" class="col-md-5">
                    <div class="form-group">
                      <label class="form-label">No of Cluster</label>
                      <input type="text" [readonly]="!selectedAlgoOption_others"
                             formControlName="noOfCluster" class="form-control"
                             placeholder="Enter the Number of Cluster" />
                    </div>
                  </div>
                  <div [ngClass]="{'disabled':!selectedAlgoOption_others}" *ngIf="this.required_others == true" class="col-md-5">
                    <div class="form-group">
                      <label class="form-label myw-required">No of Cluster</label>
                      <input type="text" [readonly]="!selectedAlgoOption_others"
                             formControlName="noOfCluster" class="form-control"
                             placeholder="Enter the Number of Cluster" />
                    </div>
                  </div>
                  <div [ngClass]="{'disabled':!selectedAlgoOption_others}"  *ngIf="this.required_others == false"
                       class="col-md-5 offset-md-2" style="padding-left: 0px">
                    <div class="form-group">
                      <label class="form-label">
                        Allow max % of unclassified tickets
                      </label>
                      <input type="text" [readonly]="!selectedAlgoOption_others"
                             formControlName="exitCriteria" class="form-control"
                             placeholder="Enter allow max % of unclassified tickets" />
                    </div>
                  </div>
                  <div [ngClass]="{'disabled':!selectedAlgoOption_others}"  *ngIf="this.required_others == true"
                       class="col-md-5 offset-md-2" style="padding-left: 0px">
                    <div class="form-group">
                      <label class="form-label myw-required">
                        Allow max % of unclassified tickets
                      </label>
                      <input type="text" [readonly]="!selectedAlgoOption_others"
                             formControlName="exitCriteria" class="form-control"
                             placeholder="Enter allow max % of unclassified tickets" />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label class="form-label myw-required">Classified Based on</label>
                      <a href="javascript:;" class="btn btn-icon" title="Please select an description field having min of 51 tickets with no null values." style="cursor: pointer;">
                        <img src="assets/images/i-icon.svg" alt="Refresh" class="myw-icon myw-18">                      
                        </a> 
                      <div class="form-inline mt-2">
                        <select class="form-control" formControlName="ClassifiedBased"
                        (change)="GetQualifiedDescription('OTHERS')">
                          <option value="Select">Select</option>
                          <option *ngFor="let t of lstClassifiedBy_others" [value]="t.name">
                            {{ t.name }}
                          </option>
                        </select>
												<!-- <label class="myw-checkbox myw-radio">
													<input (click)="ClassifiedBasedONChange('Short Description','Others')" type="radio"
														value="Short Description" formControlName="classifiedBasedOn"
														checked />
													<span>Short Description</span>
												</label>
												<label class="myw-checkbox myw-radio">
													<input
														[attr.disabled]="!isResolutionDescEnabled_Others || !isResolutionDescEnabledTask_Others? 'disabled' : null"
														(click)="ClassifiedBasedONChange('Resolution Description','Others')" type="radio"
														value="Resolution Description"
														formControlName="classifiedBasedOn" />
													<span>Resolution Description</span>
												</label> -->
												<!-- <label class="myw-checkbox myw-radio">
													<input
														[attr.disabled]="!isLongDescEnabled_Others? 'disabled' : null"
														(click)="ClassifiedBasedONChange('Long Description','Others')" type="radio"
														value="Long Description"
														formControlName="classifiedBasedOn" />
													<span>Long Description</span>
												</label> -->
                        <div class="d-flex align-items-end ml-lg-auto mb-2">
                          Click here to&nbsp;<a href="javascript:;"
                            (click)="getTopKeyWords('Others',true);" title='If any filter are modified, please click on "get top keywords" to get the updated word cloud chart.'>
                            Get top keywords</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="ChartData_Others" class="col-12">
										<div class="iom-keyword">
											<div class="d-flex align-items-end justify-content-end align-items-center">
												<div class="form-inline mr-2">
													<select class="form-control control-border" (change)="getTopKeyWords('Others',false)"
													formControlName="topWordOption">
													<option *ngFor="let t of WordCloudFilterOptions" [value]="t">Top {{t}} words</option>
												  </select>
												</div>
												<!-- <a href="javascript:;" title="Minus"><img src="images/key-minus.svg" alt="Minus" class="myw-icon myw-40 mr-n2"></a>
													<a href="javascript:;" title="Plus"><img src="images/key-plus.svg" alt="Plus" class="myw-icon myw-40"></a> -->
											</div>
											<div class="card-body" id="wordcloudContent">
												<div id="containerwordCloud_Others">
													<app-word-chart [ContainerId]="containerwordCloud_Others"
														[GraphData]="ChartData_Others" [wordlength]=1></app-word-chart>
												</div>
											</div>
										</div>
									</div>
                  <!-- <div *ngIf="envVar.ClientConfiguration.isDisplayAppName == true && !InstancePAM" class="col-md-5">
                    <div *ngIf="envVar.ClientConfiguration.isMultiSelectAppName == false" class="form-group">
                      <label class="form-label myw-required">Application Name</label>
                      <select class="form-control" formControlName="applicationType">
                        <option value="Select">Select</option>
                        <option *ngFor="let t of lstapplication_others" [value]="t.name">
                          {{t.displayName}}
                        </option>
                      </select>
                    </div>
                    <div *ngIf="envVar.ClientConfiguration.isMultiSelectAppName == true && !InstancePAM"class="form-group iom-dropdown dropdown dropflat">
                      <label class="form-label myw-required">Application Name</label>
                      <a href="javascript:;" class="iom-dropdown-toggle" role="button"
                         title="{{selectedapplication_others}}" id="assignmentGroup"
                         data-bs-toggle="dropdown" data-bs-display="static" aria-haspopup="true"
                         aria-expanded="false">
                        <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;color: #495057;">
                          {{selectedapplication_others}}
                        </div>
                      </a>
                      <div class="dropdown-menu" aria-labelledby="assignmentGroup">
                        <div class="dropdown-body">
                          <div class="iom-dropdown-scroll">
                            <div class="fs-16 mb-2">
                              <label class="myw-checkbox">
                                <input type="checkbox" #selectedAllApplication
                                       (change)="selectAllApplication('Others')"
                                       formControlName="selectAllApplication" />
                                <span>All</span>
                              </label>
                            </div>
                            <div *ngIf="lstapplication_others"
                                 class="row myw-grid row-cols-2 row-cols-lg-2">
                              <ng-container *ngFor="let d of lstapplication_others; let i = index">
                                <div class="col" *ngIf="d.name != 'All'" formArrayName="applicationType">
                                  <label class="myw-checkbox">
                                    <input type="checkbox"
                                           (change)="selectApplication('Others')"
                                           value="d.name" [formControlName]="i" />
                                    <span>{{d.displayName}}</span>
                                  </label>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  
                  <div class="col" *ngIf="isAddkeywordsEnabled_Others">
                    <div class="form-group">
                      <label class="form-label">Add/Delete Stopwords</label>
                      <div class="form-group iom-multiselect">
                        <label>Language : </label>
                        <select class="form-control" style="width: 200px" [(ngModel)]='selectedStdLanguageOthers' formControlName="ignorekeywordLanguage"
                                            (change)="GetSelectedLanguage($event,'others')">
                                            <option value="Select">Select</option>
                                                <option *ngFor="let t of selectedLanguage_Other"
                                                    [value]="t">
                                                    {{t}}</option>
                                            </select>
                      </div>
                      <input type="text" formControlName="ignorekeyword" class="form-control"
                             name="ignoreword" placeholder="Enter Keyword" />
                    </div>
                  </div>
                  <div class="col-auto d-flex align-items-end" *ngIf="isAddkeywordsEnabled_Others">
                    <div class="form-group">
                      <button type="button" (click)="addIgnoreKeyword('others')"
                              class="btn btn-primary">
                        Add
                      </button>
                    </div>
                  </div>
                  <div class="col-12" *ngIf="isAddkeywordsEnabled_Others && enableBox_Others">
                    <div class="form-group mb-0">
                      <div rows="4">
                        <span class="tag-item" *ngFor="let word of lstIgnoreKeys_others"
                              name="igonorew">
                          {{word}}
                          <span class="remove-tag" (click)="RemoveKeyword(word,'others')"
                                style="cursor: pointer;">×</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-right my-4">
              <!-- <a class="btn btn-primary link" (click)="navigateToDeepDive()" style="cursor: pointer;">Create
              Deepdive</a> -->
              <button type="button" class="btn btn-secondary mr-3"
                      (click)="CancelTicketUpload()" style="cursor: pointer; width: 7rem;">
                Cancel
              </button>
              <button type="submit" class="btn btn-primary link" style="cursor: pointer; width: 7rem;">Create</button>
            </div>
            </form>
          </div>
          <div *ngIf="enableSearch" class="suportgrp-section">
            <label class="form-label mb-3">Select {{ lstMappingConfig_ao.FilterName }} </label>
            <div  *ngIf="enableSearchAO">
              <form autocomplete="off" *ngIf="isDataAvailable" [formGroup]="textConfigForm">
                <div formGroupName="AOGroup" class="tab-pane show active" id="apps" role="tabpanel"
                aria-labelledby="apps-tab" [ngClass]="{ active: isLoadAoPill }">
                <div class="col-12" style="height:auto;">
                  <div class="form-group">                  
                            <div>
                              <input (keyup)="searchAssignment('ao')" id="txtSearchAO" formControlName="searchText" type="text"
                                class="form-control control-border" placeholder="Search {{
                                  lstMappingConfig_ao.FilterName
                                }}" />
                            </div>                       
                          <div class="iom-dropdown-scroll">
                            <div class="fs-16 form-inline mt-2">
                              <label class="myw-checkbox">
                                <input id="selectAllConfigAO" type="checkbox" #selectedAllAoId (change)="selectAllConfig('ao')"
                                  formControlName="selectAllConfig" [attr.disabled]="this.textConfigForm.value.AOGroup.searchText != '' ? '' : null" />                               
                                <span>ALL</span>
                              </label>
                              <label class="myw-checkbox">
                                <input id="selectAllSearchAO" type="checkbox"  #selectedSearchAllAoId (change)="selectAllSearchConfig('ao')"
                                  formControlName="selectAllSearchConfig" [attr.disabled]="this.textConfigForm.value.AOGroup.searchText == '' || this.lstFilterMappingConfig_aoSearch == null ? '' : null"/>
                                <span style="left: 120px;">Select ALL with searched text "{{this.textConfigForm.value.AOGroup.searchText}}" </span>                             
                              </label>
                            </div>
                            <div *ngIf="lstFilterMappingConfig_ao" class="
                                row
                                myw-grid
                                row-cols-4 row-cols-lg-4
                              ">
                              <ng-container *ngFor="
                                  let d of lstFilterMappingConfig_ao;   
                                  let i = index                             
                                ">
                                <div class="col" formArrayName="mappingConfigs" *ngIf="d.name != 'All'">
                                  <label class="myw-checkbox my-width">
                                    <input [attr.id]="'aoSearch_' + d.indexNo" type="checkbox" (change)="selectConfigSearch('ao',d.name)" value="d.name"
                                      [formControlName]="i" />
                                    <span>{{ d.name }}</span>
                                  </label>
                                </div>
                              </ng-container>
                            </div>
                          </div>
      
                          <div class="text-right mt-4">
                            <button type="button" style="width: 10%; margin-left: 20px" class="btn btn-secondary mr-3" 
                            (click)="ClearAllvalues('ao')" [ngClass]="{'disabled': !isClearAll}"> Clear All </button>
                            <button type="button" style="width: 10%; margin-left: 20px" class="btn btn-secondary mr-3" 
                            (click)="CancelSearch('ao')"> Cancel </button>
                            <a href="javascript:;" (click)="ApplyChanges('ao')" [ngClass]="{'disabled': !enableApply}" class="btn btn-primary supportgrp-optapply"
                              style="width: 7 rem">Apply</a>
                          </div>
                        </div>
                        </div>
                      </div>                 
              </form>
            </div>
          <div *ngIf="enableSearchIO">
            <form autocomplete="off" *ngIf="isDataAvailable" [formGroup]="textConfigForm">
              <div formGroupName="IOGroup" class="tab-pane show active" id="apps" role="tabpanel"
              aria-labelledby="apps-tab" [ngClass]="{ active: isLoadIoPill }">
              <div class="col-12" style="height:auto;">
                <div class="form-group">                  
                          <div>
                            <input (keyup)="searchAssignment('io')" id="txtSearchIO" formControlName="searchText" type="text"
                              class="form-control control-border" placeholder="Search {{
                                lstMappingConfig_io.FilterName
                              }}" />
                          </div>                       
                        <div class="iom-dropdown-scroll">
                          <div class="fs-16 form-inline mt-2">
                            <label class="myw-checkbox">
                              <input id="selectAllConfigIO" type="checkbox" #selectedAllIoId (change)="selectAllConfig('io')"
                                formControlName="selectAllConfig" [attr.disabled]="this.textConfigForm.value.IOGroup.searchText != '' ? '' : null" />
                              <span>ALL</span>
                            </label>
                            <label class="myw-checkbox">
                              <input id="selectAllSearchIO" type="checkbox" #selectedSearchAllIoId (change)="selectAllSearchConfig('io')"
                                formControlName="selectAllSearchConfig" [attr.disabled]="this.textConfigForm.value.IOGroup.searchText == '' || this.lstFilterMappingConfig_ioSearch == null ? '' : null"/>
                              <span style="left: 120px;">Select ALL with searched text "{{this.textConfigForm.value.IOGroup.searchText}}"</span>
                            </label>
                          </div>
                          <div *ngIf="lstFilterMappingConfig_io" class="
                              row
                              myw-grid
                              row-cols-4 row-cols-lg-4
                            ">
                            <ng-container *ngFor="
                                let d of lstFilterMappingConfig_io;   
                                let i = index                             
                              ">
                              <div class="col" formArrayName="mappingConfigs" *ngIf="d.name != 'All'">
                                <label class="myw-checkbox my-width">
                                  <input [attr.id]="'ioSearch_' + d.indexNo" type="checkbox" (change)="selectConfigSearch('io',d.name)" value="d.name"
                                    [formControlName]="i" />
                                  <span>{{ d.name }}</span>
                                </label>
                              </div>
                            </ng-container>
                          </div>
                        </div>
      
                        <div class="text-right mt-4">
                          <button type="button" style="width: 10%; margin-left: 20px" class="btn btn-secondary mr-3" 
                          (click)="ClearAllvalues('io')" [ngClass]="{'disabled': !isClearAll}"> Clear All </button>
                          <button type="button" style="width: 10%; margin-left: 20px" class="btn btn-secondary mr-3" 
                          (click)="CancelSearch('io')"> Cancel </button>
                          <a href="javascript:;" (click)="ApplyChanges('io')" [ngClass]="{'disabled': !enableApply}" class="btn btn-primary supportgrp-optapply"
                            style="width: 7 rem">Apply</a>
                        </div>
                      </div>
                      </div>
                    </div>                 
            </form>
          </div>
          <div *ngIf="enableSearchOth">
            <form autocomplete="off" *ngIf="isDataAvailable" [formGroup]="textConfigForm">
              <div formGroupName="OthersGroup" class="tab-pane show active" id="apps" role="tabpanel"
              aria-labelledby="apps-tab" [ngClass]="{ active: isLoadAoPill }">
              <div class="col-12" style="height:auto;">
                <div class="form-group">                  
                          <div>
                            <input (keyup)="searchAssignment('others')" id="txtSearchOth" formControlName="searchText" type="text"
                              class="form-control control-border" placeholder="Search {{
                                lstFilterMappingConfig_others.FilterName
                              }}" />
                          </div>                       
                        <div class="iom-dropdown-scroll">
                          <div class="fs-16 form-inline mt-2">
                            <label class="myw-checkbox">
                              <input id="selectAllConfigOth" type="checkbox" #selectedAllOthersId (change)="selectAllConfig('others')"
                                formControlName="selectAllConfig" [attr.disabled]="this.textConfigForm.value.OthersGroup.searchText != '' ? '' : null" />                               
                              <span>ALL</span>
                            </label>
                            <label class="myw-checkbox">
                              <input id="selectAllSearchOth" type="checkbox" #selectedSearchAllOthersId (change)="selectAllSearchConfig('others')"
                                formControlName="selectAllSearchConfig" [attr.disabled]="this.textConfigForm.value.OthersGroup.searchText == '' || this.lstFilterMappingConfig_othSearch == null ? '' : null"/>
                              <span style="left: 120px;">Select ALL with searched text "{{this.textConfigForm.value.OthersGroup.searchText}}"</span>                            
                            </label>
                          </div>
                          <div *ngIf="lstFilterMappingConfig_others" class="
                              row
                              myw-grid
                              row-cols-4 row-cols-lg-4
                            ">
                            <ng-container *ngFor="
                                let d of lstFilterMappingConfig_others;   
                                let i = index                             
                              ">
                              <div class="col" formArrayName="mappingConfigs" *ngIf="d.name != 'All'">
                                <label class="myw-checkbox my-width">
                                  <input [attr.id]="'othSearch_' + d.indexNo" type="checkbox" (change)="selectConfigSearch('others',d.name)" value="d.name"
                                    [formControlName]="i" />
                                  <span>{{ d.name }}</span>
                                </label>
                              </div>
                            </ng-container>
                          </div>
                        </div>
      
                        <div class="text-right mt-4">
                          <button type="button" style="width: 10%; margin-left: 20px" class="btn btn-secondary mr-3" 
                          (click)="ClearAllvalues('others')" [ngClass]="{'disabled': !isClearAll}"> Clear All </button>
                          <button type="button" style="width: 10%; margin-left: 20px" class="btn btn-secondary mr-3" 
                          (click)="CancelSearch('others')"> Cancel </button>
                          <a href="javascript:;" (click)="ApplyChanges('others')" [ngClass]="{'disabled': !enableApply}" class="btn btn-primary supportgrp-optapply"
                            style="width: 7 rem">Apply</a>
                        </div>
                      </div>
                      </div>
                    </div>                 
            </form>
          </div>
        </div>
        </div>      
    </div>    
  </div>
</div>

</div>






